import notificationsType from "../types/notifications-type";
const initialState = {
    loading: false,
    error: null
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case notificationsType.CREATE_NOTIFICATION:
            return {
                ...state,
                loading: true
            };
        case notificationsType.CREATE_NOTIFICATION_COMMIT:
            return {
                ...state,
                loading: false,
                error: null
            };
        case notificationsType.CREATE_NOTIFICATION_ROLLBACK:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};
